import axiosInstance from '../axiosInstance';

export async function submitInitialReport(payload) {
    const response = await axiosInstance.post('/jha/initial-report', payload);
    return response.data;
}
